import { observable, autorun, runInAction, action, computed, makeObservable, } from 'mobx';
export class HistoryStore {
    constructor(client) {
        this.configId = undefined;
        this.data = undefined;
        this.consentShortScope = undefined;
        makeObservable(this, {
            configId: observable,
            data: observable,
            gotoPage: action,
            currentPage: computed,
        });
        this.client = client;
        autorun(() => {
            if (this.configId) {
                this.data = undefined;
                void this.gotoPage(1);
            }
        });
    }
    async loadPage(offset) {
        const data = await this.client.getConsentHistory(this.configId, offset, 5);
        runInAction(() => {
            this.data = data;
        });
    }
    async gotoPage(goto = 1) {
        const offset = this.data ? (goto - 1) * this.data.limit : 0;
        await this.loadPage(offset);
    }
    get currentPage() {
        if (!this.data)
            return 0;
        const { offset, limit } = this.data;
        return Math.floor(offset / limit);
    }
}
//# sourceMappingURL=HistoryStore.js.map